import React from "react";
import { ErrorCountContainer } from "../../../containers";

const ErrorCount = (props) => {
  return <ErrorCountContainer {...props} />;
};

export default ErrorCount;
